import { useWatch } from "react-hook-form";
import { getARUniRecognizedSpecialitiesAutocomplete } from "../../../../../../../axios/api/services";
import ARUniFreeSoloAutocompleteField from "../../../../../common/form/fields/ARUniFreeSoloAutocompleteField";
import { useEffect } from "react";
import useAppDispatch from "../../../../../../../hooks/redux/base/useAppDispatch";
import { profGroupThunk } from "../../../../../../../store/redux/slice/AppData/profGroup";
import useAppSelector from "../../../../../../../hooks/redux/base/useAppSelector";
import { NomenclatureAutocompleteFormField } from "@duosoftbg/nacid-components";

const ARUniEntryRequestRecognizedSpecialityProfGroupField = () => {
  const dispatch = useAppDispatch();

  const recognizedEduLevelId = useWatch({ name: "recognizedEducationLevel.id" });
  const profGroupId = useWatch({ name: "recognizedProfGroup.id" });

  const profGroupThunkState = useAppSelector((state) => {
    return state.AppData.profGroup;
  });

  useEffect(() => {
    if ("DOC" === recognizedEduLevelId) {
      dispatch(profGroupThunk());
    }
  }, [dispatch, recognizedEduLevelId]);

  if (!recognizedEduLevelId || recognizedEduLevelId === "") {
    return null;
  }
  if ("DOC" !== recognizedEduLevelId) {
    return (
      <ARUniFreeSoloAutocompleteField
        required={true}
        labelCode={"l.arUniEntryRequest.recognizedSpeciality"}
        fieldName={"recognizedSpeciality"}
        autocompleteFn={getARUniRecognizedSpecialitiesAutocomplete}
      />
    );
  } else {
    return (
      <NomenclatureAutocompleteFormField
        onlyActive
        required={true}
        fieldName={"recognizedProfGroup.id"}
        labelCode={"l.arUniEntryRequest.recognizedProfGroup"}
        thunkState={profGroupThunkState}
        thunkFn={profGroupThunk}
        initialValue={profGroupId}
      />
    );
  }
};
export default ARUniEntryRequestRecognizedSpecialityProfGroupField;
